module.exports = __webpack_public_path__ + "fonts/abc1dd36099c1a46676cce1f7bb93757.txt";